module.exports = __webpack_public_path__ + "img/img02.53cad962.png";